

exports.__esModule = true;
exports.getInvalidAddressRequiredParams = getInvalidAddressRequiredParams;
exports.getMerchantDetails = getMerchantDetails;

var _customUtil = require('../../../js/lib/customUtil');

var _xclickUtil = require('../../../js/lib/xclickUtil.js');

function getInvalidAddressRequiredParams(xclickParams) {
    if (!xclickParams) {
        return;
    }
    var jsonParams = _customUtil.customUtil.decodeAndParse(xclickParams);
    var requiredDetailsForAddressOverride = void 0;
    var outputParams = {};
    if ((0, _xclickUtil.isAddressOverride)(jsonParams)) {
        requiredDetailsForAddressOverride = mapAddressOverrideParams(jsonParams);
    }
    outputParams.requiredDetailsForAddressOverride = requiredDetailsForAddressOverride;
    outputParams.payeeEmail = jsonParams['merchant_email'];
    outputParams.merchantId = jsonParams['merchant_id'];
    return outputParams;
}

function getMerchantDetails(buttonItemDetails) {
    if (!buttonItemDetails) {
        return {};
    }
    return {
        imageUrl: buttonItemDetails && buttonItemDetails.urls && buttonItemDetails.urls.image_url,
        brand_name: buttonItemDetails && buttonItemDetails.payee && buttonItemDetails.payee.business_name,
        merchant_email: buttonItemDetails && buttonItemDetails.payee && buttonItemDetails.payee.email
    };
}

var mapAddressOverrideParams = function mapAddressOverrideParams(jsonParams) {
    var buttonParams = {};
    buttonParams = (0, _xclickUtil.mapCartParams)(buttonParams, jsonParams);
    buttonParams = mapUrls(buttonParams, jsonParams);
    buttonParams = (0, _xclickUtil.mapPayeePayerParams)(buttonParams, jsonParams);
    buttonParams = (0, _xclickUtil.mapShippingAddress)(buttonParams, jsonParams);
    return buttonParams;
};

var mapUrls = function mapUrls(buttonParams, jsonParams) {
    var cartUrlParams = {
        'image_url': 'image_url',
        'cancel_return': 'cancel_return'
    };
    return (0, _xclickUtil.mapUrlParams)(buttonParams, jsonParams, cartUrlParams);
};
_customUtil.customUtil;

_xclickUtil.mapCartParams;

_xclickUtil.mapUrlParams;

_xclickUtil.isAddressOverride;

_xclickUtil.mapShippingAddress;

_xclickUtil.mapPayeePayerParams;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-error/xo-invalid-address-error/util.js
// module id = ./pages/xo-error/xo-invalid-address-error/util.js
// module chunks = 1